import React from "react";

export type StripeLookupKey =
  | "pro_v3"
  | "edge_v3"
  | "extension_v3-pro_v3"
  | "extension_v3-edge_v3"
  | "activation_v3-pro_v3"
  | "activation_v3-edge_v3"
  | "cloud_credits"
  | "offer"
  | "unknown";

export type StripeProductName =
  | "Cloud Credits"
  | "Offer"
  | "Support Extension"
  | "PioSOLVER"
  | "PioSOLVER 3.0 Edge"
  | "PioSOLVER 3.0 Pro";

  type ResultPageProps = {
    productName: StripeProductName;
  };

  function UserEmail({ customerEmail }: { customerEmail?: string }) {
    if (!customerEmail) return null;
    return (
      <span>
        at <i>{customerEmail}</i>
      </span>
    );
  }

  export function Header() {
    return (
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-baseline border-bottom my-2">
          <div className="d-flex align-items-baseline">
            <img
              alt="piosolver logo"
              className="me-2"
              src="/logo192.png"
              style={{ width: "1.5em" }}
            />
            <h3>PioSOLVER</h3>
          </div>
        </div>
      </div>
    );
  }

  export function ResultProcessingHeader() {
    return <h3>Processing order, please wait...</h3>;
  }

  export function ResultSuccessHeader({ productName }: ResultPageProps) {
    if (productName === "Offer" || productName === "Cloud Credits")
      return <h3>Thank you for your purchase!</h3>;
    return <h3>Thank you for your purchase!</h3>;
  }

  interface ResultSuccessDetailsProps extends ResultPageProps {
    customerEmail?: string;
  }

  export function ResultSuccessDetails({
    productName,
    customerEmail
  }: ResultSuccessDetailsProps) {
    if (productName === "Offer") {
      return (
        <div className="mt-4">
          <p>
            We will be reaching out to you shortly{" "}
            <UserEmail customerEmail={customerEmail} /> to follow up on your
            purchase.
          </p>
          <p className="text-secondary">
            All orders are processed manually, and it may take up to 1 business
            day for processing. (PioSOLVER is based in Europe, so please be
            patient if the order was issued during European night).
          </p>
        </div>
      );
    }
    if (productName === "Cloud Credits") {
      return (
        <div className="mt-4">
          <p>
            You can return to <a href="https://cloud.piosolver.com">PioCloud</a>{" "}
            and you should see the increased credit balance shortly.
          </p>
          <p className="text-secondary">
            If the credits do not appear after a few minutes, try the
            &ldquo;Refresh&rdquo; button or refresh the entire page.
          </p>
        </div>
      );
    }
    if (productName === "PioSOLVER") {
      return (
        <div className="mt-4">
          <p>
            You should shortly receive an email{" "}
            <UserEmail customerEmail={customerEmail} /> with information about
            your purchase.
          </p>
          <p className="text-secondary">
            All orders are processed manually, and it may take up to 1 business
            day for processing. (PioSOLVER is based in Europe, so please be
            patient if the order was issued during European night).
          </p>
        </div>
      );
    }
    return (
      <div className="mt-4">
        <p>
          You should receive an email{" "}
          <UserEmail customerEmail={customerEmail} /> with installation
          information soon, but please give us some time to process your order.
        </p>
        <p className="text-secondary">
          All orders are processed manually, and it may take up to 1 business
          day for processing. (PioSOLVER is based in Europe, so please be
          patient if the order was issued during European night).
        </p>
      </div>
    );
  }

// type ResultSuccessProps = CartStateProps & {
//   submitResult: CheckoutResult;
// };
//
// function ResultSuccess({ state, submitResult }: ResultSuccessProps) {
//   const transactionId = submitResult.successDetails?.transactionId;
//   const amount = submitResult.successDetails?.amount;
//   const contactEmail = submitResult.successDetails?.email;
//   return (
//     <div>
//       <ResultSuccessHeader orderType={state.orderType} />
//       <div className="mb-4" style={{ maxWidth: "500px" }}>
//         <Table size="sm">
//           <tbody>
//             <tr>
//               <th scope="row">Transaction Id</th>
//               <td>{transactionId}</td>
//             </tr>
//             <tr>
//               <th scope="row">Email</th>
//               <td>{contactEmail}</td>
//             </tr>
//             <tr>
//               <th scope="row">Amount</th>
//               <td>{amount}</td>
//             </tr>
//           </tbody>
//         </Table>
//         <ResultSuccessDetails orderType={state.orderType} />
//         <div className="d-flex flex-row-reverse mt-5">
//           <Button href="/">Back Home</Button>
//         </div>
//       </div>
//     </div>
//   );
// }
